"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalProvider = void 0;
class LocalProvider {
    init(...args) {
        console.info("Initialized decodable agent with local provider");
    }
    cleanup(...args) {
        console.info("Cleaned up decodable agent with local provider");
    }
    setUser(user) {
        console.info("Setting user", user);
    }
    setUserProperty(key, value) {
        console.info("Setting property on user", { [key]: value });
    }
    recordInfo(message, messageContext) {
        console.log(message, messageContext);
    }
    recordWarn(message, messageContext, error) {
        console.warn(message, messageContext, error);
    }
    recordError(message, error, messageContext) {
        console.error(message, error, messageContext);
    }
}
exports.LocalProvider = LocalProvider;
